import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import { EditorEntity } from '../editor.entity';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';

export const STATE_NAME = 'editorEntity';

// Create the NGXS state
export const EditorEntityState: GenericEntityStateClass<EditorEntity> =
  createEntityState<EditorEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class EditorEntityService extends EntityService<EditorEntity> {
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);

  constructor() {
    super();
    this.resourceType = 'editors';
    this.stateClass = EditorEntityState;

    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): EditorEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
